/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib types
import { AppShellNavbarProps } from '@mantine/core';

/* -------------------------------------------------------------------------- */
/*                                    Types                                   */
/* -------------------------------------------------------------------------- */

export interface NavBarProps extends Omit<AppShellNavbarProps, 'children'> {}

export const NAVBAR_STATES = ['expanded', 'collapsed'] as const;
export type NavBarState = (typeof NAVBAR_STATES)[number];

export enum NavBarLevel {
  Primary = 'primary',
  Secondary = 'secondary',
}
